import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.orderProcessSection.title',
    defaultMessage: 'Process',
    description: 'Title of the process section',
  },
  actions: {
    edit: {
      label: {
        id: 'pages.orderProcessSection.actions.edit.label',
        defaultMessage: 'Edit',
        description: 'Label of the edit action in the process section',
      },
    },
  },
  processing: {
    allocation: {
      id: 'pages.orderProcessSection.processing.allocation',
      defaultMessage: 'Allocation',
      description: 'Label of the processing property allocation',
    },
    capture: {
      id: 'pages.orderProcessSection.processing.capture',
      defaultMessage: 'Capture',
      description: 'Label of the processing property allocation',
    },
    confirm: {
      id: 'pages.orderProcessSection.processing.confirm',
      defaultMessage: 'Confirm',
      description: 'Label of the processing property confirm',
    },
    fulfilment: {
      id: 'pages.orderProcessSection.processing.fulfilment',
      defaultMessage: 'Fulfilment',
      description: 'Label of the processing property fulfilment',
    },
  },
  processSettings: {
    title: {
      id: 'pages.orderProcessSection.processSettings.title',
      defaultMessage: 'Process settings',
      description: 'Title of the process settings drawer',
    },
  },
  feedback: {
    processSettingsUpdated: {
      id: 'pages.orderProcessSection.feedback.processSettingsUpdated',
      defaultMessage: 'Process settings updated',
      description: 'Succes message of the update process settings action',
    },
    processSettingsNotUpdated: {
      id: 'pages.orderProcessSection.feedback.processSettingsNotUpdated',
      defaultMessage: 'Process settings could not be updated',
      description: 'Error message of the update process settings action',
    },
  },
};

export default defineMessages(translations);
